<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'GtrBadgePreview',
  props: {
    badge: {
      type: String,
      required: true,
      default: ''
    },
    includeFrame: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  computed: {
    parsedBadge (): string {
      return this.badge?.substring(this.badge?.indexOf('<svg')) ?? ''
    }
  }
})
</script>

<template>
  <div class="badge-preview" :class="{ frame: includeFrame }">
    <v-progress-circular
        v-if="loading"
        :size="100"
        color="var(--personify-violet)"
        indeterminate
    />
    <div v-else>
      <div v-html="parsedBadge" />
    </div>
  </div>
</template>

<style>
.badge-preview {
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.badge-preview.frame {
  background-color: var(--purple-grey-10);
  border: 1px solid #C9C9C9;
  border-radius: 5px;
  padding: 20px;
}
.badge-preview svg {
  max-width: 100%;
  height: auto;
}
.badge-preview svg #nonPrintLayer {
  display: block !important;
  visibility: visible !important;
  opacity: 1.0 !important;
}
</style>
